/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import SearchComponent from "../../../components/SearchComponent";
import Compdirection from "../../../themes/CompDirection";
import { fonts, themes } from "../../../themes/themes";
import CustomModal from "../../CustomModal/CustomModal";
import ModalHeader from "../../CustomModal/ModalHeader";
import "../TrainingModal.css";
import EmpProfile from "../../../components/EmpProfile/EmpProfile";
import _ from "lodash";

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trainingEva: any;
  editTraineesData: any;
  trans: any;
  i18n?: any;
  callBackGetData: (data: any) => void;
}
const ViewCompTrainingPresenter = ({
  isModalOpen,
  closeModal,
  trainingEva,
  editTraineesData,
  trans,
  callBackGetData,
}: ModalProps) => {
  const [pageSize, setPageSize] = React.useState<number>(30);
  const [textFiltertraining, setTextFiltertraining] = useState("");
  const filtertrainingList = () => {
    if (textFiltertraining.length) {
      const txt = textFiltertraining.toLowerCase();
      const res = _.filter(trainingEva, function (e) {
        return (
          e?.employee?.first_name?.toLowerCase().includes(txt) ||
          e?.employee?.last_name?.toLowerCase().includes(txt)
        );
      });

      {
        return res;
      }
    } else {
      return trainingEva;
    }
  };
  const tableData: any = filtertrainingList().map((tEv: any) => {
    const min_Score = editTraineesData?.training_type?.min_score;

    let status: any = "";
    if (tEv?.evaluation_status == 0) {
      status = "Absent";
    } else {
      if (min_Score > 0) {
        const min_score: any = min_Score;

        if (min_score) {
          if (tEv?.score >= min_score) {
            status = "Passed";
          } else {
            status = "Failed";
          }
        }
      } else {
        status = "Completed";
      }
    }
    const rowData: any = {
      id: tEv?.id,
      empId: tEv?.emp_id,
      employee: tEv?.employee
        ? tEv?.employee?.first_name + " " + tEv?.employee?.last_name
        : "--",
      avatar: tEv?.employee?.user ? tEv?.employee?.user?.profile_pic : "",
      designation: tEv?.employee?.emp_job_detail?.designation?.name,
      score: tEv?.score ? tEv?.score : 0,
      status: status,
    };
    return rowData;
  });
  const tableColumns: any = [
    {
      field: "empId",
      headerName: trans("Emp Id"),
      width: 160,
      headerClassName: "header",
      height: 100,
    },

    {
      field: "employee",
      headerName: trans("Employee"),
      width: 250,
      headerClassName: "header",
      height: 100,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <EmpProfile avatar={params.row.avatar} name={params.row.employee} />
        );
      },
    },
    {
      field: "designation",
      headerName: trans("Designation"),
      width: 200,
      headerClassName: "header",
      height: 100,
      // flex: 1,
    },
    {
      field: "score",
      headerName: trans("Score"),
      width: 100,
      headerClassName: "header",
      height: 100,
    },

    {
      field: "status",
      headerName: trans("Status"),
      width: 140,
      headerClassName: "header",
      height: 100,

      renderCell: (params: any) => {
        return params?.row?.status == "Present" ? (
          <Typography
            style={{
              color: themes.green,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: "capitalize",
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : params?.row?.status == "Absent" ? (
          <Typography
            style={{
              color: themes.red,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: "capitalize",
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : params?.row?.status == "Passed" ? (
          <Typography
            style={{
              color: themes.green,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: "capitalize",
              fontWeight: "bold",
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : params?.row?.status == "Failed" ? (
          <Typography
            style={{
              color: themes.red,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: "capitalize",
              fontWeight: "bold",
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : params?.row?.status == "Completed" ? (
          <Typography
            style={{
              color: "#0C2372",
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: "capitalize",
              fontWeight: "bold",
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : (
          ""
        );
      },
    },
  ];
  const handleGetTextFilter = (value: any) => {
    setTextFiltertraining(value);
  };
  const handleexportAll = () => {
    //setExportData(trainingEva[0]?.training_id);
    callBackGetData({
      event: "training",
      user_id: "",
      company_id: "",
      training_id: trainingEva[0]?.training_id,
    });
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="750px"
      modalWidth="1000px"
    >
      <ModalHeader
        modal={{ modal_title: trans("View Details") }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: "10px",
          }}
        >
          <Grid item xs={12}>
            <Box className="modalBox24">
              <Typography className="title1">
                {trans("Total Trainee :")} {trainingEva?.length}
              </Typography>
              <Grid container style={{ marginTop: "1em" }}>
                <Grid item style={{ flexGrow: 1 }}>
                  <SearchComponent onChange={handleGetTextFilter} />
                </Grid>
                <Grid item>
                  <Button
                    className="export-button1"
                    startIcon={<i className="las la-file-export"></i>}
                    onClick={() => handleexportAll()}
                  >
                    {trans("Export All")}
                  </Button>
                </Grid>
              </Grid>
              <Box
                sx={{
                  "& .header": {
                    backgroundColor: "#F5F5F5",
                  },
                }}
                className="mark_as_complete_table"
              >
                <DataGrid
                  sx={{
                    fontSize: fonts.subtitle,
                    color: "#081735",
                    fontFamily: fonts.fontFamily,
                    marginTop: "1.5em",
                  }}
                  autoHeight
                  disableColumnFilter
                  pageSize={pageSize}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  rowsPerPageOptions={[30, 35]}
                  disableSelectionOnClick
                  rows={tableData}
                  columns={tableColumns}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Compdirection>
    </CustomModal>
  );
};
export default ViewCompTrainingPresenter;
